<template>
    <span>
        <vs-checkbox v-model="selecionadoInner" @change="invokeParentMethod" size="small"></vs-checkbox>                            
    </span>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: function () {
    return {
      selecionadoInner: null
    };
  },
  beforeMount() {},
  mounted() {
      this.selecionadoInner = this.params.node.data.selecionado;
  },
  methods: {
    invokeParentMethod() {
        this.params.node.data.selecionado = this.selecionadoInner;
        this.params.node.setSelected(this.selecionadoInner);
        
    },
  },
});
</script>